export const provisionalData = [
    {
        id: 1,
        seller: "100Pay Servicos Administrativos E Desenvolvimento De Software",
        status: "Ativo",
        ein: "1516230326492",
        mcc: "Diversos/Computadores, Periféricos e Software",
    },
    {
        id: 2,
        seller: "360 ZEAL MARKETING DIGITAL LTDA",
        status: "Ativo",
        ein: "3454530326492",
        mcc: "Educação/Escola / Cursos em geral",
    },
    {
        id: 3,
        seller: "COLEGIO MOREIRA XAVIER LTDA",
        status: "Inativo",
        ein: "5726230326369",
        mcc: "Educação/Escola / Cursos em geral",
    },
]

export const provisionalDataForClient = [
    {
        id: 215,
        firstName: "Francisco",
        lastName: "Marques",
        status: "Ativo",
        cpf: "61944246304",
        creator: "SIFRAPAG2",
        card: true
    },
    {
        id: 216,
        firstName: "Paula",
        lastName: "Silva",
        status: "Ativo",
        cpf: "61944246304",
        creator: "SIFRAPAG2",
        card: true
    },
]

export const clientDashBoard = [
    {
        id: 0,
        value: 46,
        firstName: "Paula",
        lastName: "Almeida",
        status: "Aprovado",
        cpf: "61944246304",
        dueDate: "08/07/2020",
        planName: "Premium",
        paymentMethod: "Credit 2578",
        tax: 2.98,
    },
    {
        id: 1,
        value: 47,
        firstName: "Paula",
        lastName: "Almeida",
        status: "Recusado",
        cpf: "61944246304",
        dueDate: "25/07/2020",
        planName: "Standart",
        paymentMethod: "Boleto",
        tax: 3.08,
    },
    {
        id: 2,
        value: 580,
        firstName: "Luis",
        lastName: "Costa",
        status: "Pendente",
        cpf: "34564246304",
        dueDate: "08/07/2020",
        planName: "Premium",
        paymentMethod: "Credit 2578",
        tax: 10.45,
    },
    {
        id: 3,
        value: 80,
        firstName: "Paula",
        lastName: "Almeida",
        status: "Pendente",
        cpf: "61944246304",
        dueDate: "08/07/2020",
        planName: "Standart",
        paymentMethod: "Credit 2578",
        tax: 4.98,
    },
]

export const subscriptionData = [
    {
        id: 215,
        firstName: "Francisco",
        lastName: "Marques",
        status: "Ativo",
        cpf: "61944246304",
        planName: "Premium",
        initialCharge: "31/01/2020",
        subscriptionValue: "2.000"
    },
    {
        id: 216,
        firstName: "Jeferson",
        lastName: "Juliani",
        status: "Ativo",
        cpf: "61944246304",
        planName: "Standard",
        initialCharge: "10/03/2020",
        subscriptionValue: "1.000"
    }
]

export const recurrenceData = [
    {
        id: 343,
        sellerId: 1,
        planName: "Premium",
        frequence: "Diariamente",
        status: "Ativo",
        interval: 0,
        paymentMethod: "Crédito",
        planValue: "1.000",
        setupValue: "1.000",
        duration: 1
    },
    {
        id: 341,
        sellerId: 2,
        planName: "Standard",
        frequence: "Mensal",
        status: "Inativo",
        interval: 1,
        paymentMethod: "Boleto",
        planValue: "5.000",
        setupValue: "5.000",
        duration: 7
    },
]

export const paymentOptionsData = [
    {
        id: 0,
        bank: "Itaú Unibanco S.A.",
        agency: 8454,
        digit: "",
        holder: "SifraPag",
        accountType: "Conta corrente",
        account: 874751,
        cnpj: "56.432.673/0001-19",
        primary: true,
    },

    {
        id: 1,
        bank: "Bradesco",
        agency: 2356,
        digit: "",
        holder: "SifraPag",
        accountType: "Conta corrente",
        account: 104731,
        cnpj: "56.432.673/0001-19",
        primary: false,
    },
]

export const lastsTransfers = [
    {
        id: 0,
        type: "subscription",
        firstName: "Paula",
        planName: "Plano 1",
        amount: 46
    },
    {
        id: 1,
        type: "payOrder",
        firstName: "Francisco",
        planName: "Boleto",
        amount: 756
    },
    {
        id: 2,
        type: "subscription",
        firstName: "Francisco",
        planName: "Plano 2",
        amount: 88
    },
    {
        id: 3,
        type: "subscription",
        firstName: "Francisco",
        planName: "Plano 2",
        amount: 88
    },
    
]

export const usersData = [
    {
        id: 1,
        login: "jeferson.dev",
        name: "Jeferson Juliani",
        group: "Desenvolvedor",
        seller: "100pay",
        email: "jeferson@100pay.com",
        status: "Ativo"
    },
    {
        id: 2,
        login: "paula",
        name: "Paula Marques",
        group: "Admin",
        seller: "100pay",
        email: "paula@100pay.com",
        status: "Ativo"
    },
    {
        id: 3,
        login: "anabeatriz",
        name: "Ana Beatriz",
        group: "Cliente",
        seller: "Colégio Moreira",
        email: "anabeatriz02@gmail.com",
        status: "Inativo"
    },
]

export const plansData = [
    {
        id: 1,
        name: "Plano Pro MOREIRA XAVIER",
        description: "Pagamento no próximo dia útil.",
        frequence: "Diariamente",
    },
    {
        id: 2,
        name: "Plano Standard MOREIRA XAVIER",
        description: "Pagamento em 30 dias no crédito e 1 dia no débito.",
        frequence: "Semanalmente",
    },
    {
        id: 3,
        name: "Plano Pro SUPERA",
        description: "Pagamento no próximo dia útil.",
        frequence: "Mensalmente",
    },
]